
module.exports = function (ngModule) {

  ngModule.service('stateService', function () {


    return {
      selectedTrack: undefined
    };

  });

};



// WEBPACK FOOTER //
// ./src/web/main/state.service.js